import { Component, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'notifications-header-search',
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notifications-search.component.html'
})
export class NotificationsSearchComponent {
    @Input() sorted: boolean = false;
    @Input() sortDirection: string = 'asc';
    @Output() quickFilterChange = new EventEmitter<string>();
    @Output() sortChange = new EventEmitter<string>();
    public quickFilterValue = '';

    onQuickFilterChange() {
        this.quickFilterChange.emit(this.quickFilterValue);
    }

    applySort() {
        const order = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.sortChange.emit(order);
    }

    clear() {
        this.quickFilterValue = '';
        this.onQuickFilterChange();
    }
}
